import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n";

const SITE_NAME = "Ariaf Catering";

export default function SEO({ title, description, image, path }) {
  const { lang, t, tt } = useLang();
  const finalTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — ${tt({ tr: "Yılların tecrübesi, kutsal bir yolculuğun tadı.", ar: "خبرة السنين، مذاق رحلة مقدّسة.", en: "Years of craft, the taste of a sacred journey.", ru: "Годы мастерства, вкус священного пути." })}`;
  const finalDesc = description || tt({
    tr: "Türk, Arap ve Özbek mutfağıyla Mekke otellerinde Umre yolcularına günde üç öğün.",
    ar: "ضيافة تركية وعربية وأوزبكية 3 وجبات يومياً لضيوف العمرة في فنادق مكة المكرمة.",
    en: "Turkish, Arabic and Uzbek cuisine served three times daily to Umrah guests at hotels in Makkah.",
    ru: "Турецкая, арабская и узбекская кухня 3 раза в день для гостей умры в отелях Мекки.",
  });
  const finalImg = image || "https://customer-assets.emergentagent.com/job_c6bd5712-5f81-483e-8d1a-423c18662714/artifacts/8xuq627e_LOGO%20ARIAF.jpg.jpeg";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:image" content={finalImg} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      {["tr", "ar", "en", "ru"].map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={`${window.location.origin}${path || window.location.pathname}`} />
      ))}
    </Helmet>
  );
}
